import { render, staticRenderFns } from "./ecnperson.vue?vue&type=template&id=7c9dcff2&scoped=true&"
import script from "./ecnperson.vue?vue&type=script&lang=js&"
export * from "./ecnperson.vue?vue&type=script&lang=js&"
import style0 from "./ecnperson.vue?vue&type=style&index=0&id=7c9dcff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9dcff2",
  null
  
)

export default component.exports